import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterRetweetIconProps  extends SvgIconProps {}
/**
 * component used to display twitter retweet icon in twitter interaction
 * @param props - CcfTwitterRetweetIconProps
 * @example - <CcfTwitterRetweetIcon />
 * @returns SVG of twitter retweet icon in twitter interaction
 */
export function CcfTwitterRetweetIcon(props: CcfTwitterRetweetIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_retweet" clip-path="url(#clip-ic_retweet)">
        <g id="Group_121030" data-name="Group 121030" transform="translate(0 2.273)">
          <path id="Path_14085" data-name="Path 14085" d="M796.387,1259.626a.493.493,0,0,0-.7,0l-1.675,1.675v-7.167a2.471,2.471,0,0,0-2.468-2.469h-4.377a.494.494,0,1,0,0,.988h4.377a1.483,1.483,0,0,1,1.481,1.481v7.167l-1.675-1.675a.494.494,0,0,0-.7.7l2.517,2.518a.492.492,0,0,0,.7,0l2.518-2.518A.493.493,0,0,0,796.387,1259.626Z" transform="translate(-779.43 -1251.665)" />
          <path id="Path_14086" data-name="Path 14086" d="M788.794,1262.131h-4.378a1.483,1.483,0,0,1-1.481-1.481v-7.168l1.676,1.675a.492.492,0,0,0,.7,0,.5.5,0,0,0,0-.7l-2.518-2.518a.493.493,0,0,0-.7,0l-2.518,2.518a.494.494,0,0,0,.7.7l1.675-1.675v7.168a2.471,2.471,0,0,0,2.468,2.468h4.378a.494.494,0,1,0,0-.987Z" transform="translate(-779.43 -1251.665)" />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterRetweetIcon;
